"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OperatorHistoryType = void 0;
var OperatorHistoryType;
(function (OperatorHistoryType) {
    OperatorHistoryType["Primary"] = "primary";
    OperatorHistoryType["Secondary"] = "secondary";
    OperatorHistoryType["NightShift"] = "night shift";
})(OperatorHistoryType = exports.OperatorHistoryType || (exports.OperatorHistoryType = {}));
//# sourceMappingURL=operator.js.map